import React, { useMemo } from 'react';

import Modal from '~/theseus/components/Modal';

import { useDomainVerification } from '../context';
import useModalStyle from './useModalStyle';

import {
  Error,
  Loading,
  Instructions,
  DnsInput,
  Recommendations,
} from './ModalContent';

import '../style.scss';

// TODO: Migrate this to xstate core instead of fsm
export default function VerificationModal(props) {
  const { isOpen, onClose } = props;
  const { current } = useDomainVerification();
  const contentStyle = useModalStyle(current.value);

  const modalContent = useMemo(() => {
    switch (current.value) {
      case 'ERROR':
        return <Error retriesLeft />;
      case 'ERROR_FINAL':
        return <Error />;
      case 'ERROR_FINAL_NOT_OWNER':
        return <Error notOwner />;
      case 'VERIFYING_DNS':
        return <Loading />;
      case 'INSTRUCTIONS':
        return <Instructions />;
      case 'TXT_RECORD':
        return <DnsInput />;
      case 'RECOMMENDATIONS':
        return <Recommendations />;
      default:
        throw new Error(`Step ${current.value} not defined in state machine and therefore no modal content can be displayed`);
    }
  }, [current.value]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      contentStyle={contentStyle}
    >
      { modalContent }
    </Modal>
  );
}
